import TileWMS from "ol/source/TileWMS.js";

function wms({ url, layer, projection }) {
  try {
    return new TileWMS({
      url,
      params: {
        LAYERS: layer,
        TILED: true,
        FORMAT: "Image/png",
        VERSION: "1.1.1",
      },
      crossOrigin: "anonymous",
      projection,
    });
  } catch (err) {
    console.error(
      new Error(
        "[OLMap/wms] - Error when constructing WMS layer. This was most likely caused by a faulty url.",
        err
      )
    );
  }
}

export default wms;
